import pythonApiClient from "./pythonBaseApi";

const BASE = "/procesos/alimentacion/carga-comensales-logiflex";

const headersProyecto = (proyectoId) => ({
  "X-Proyecto-ID": proyectoId,
});

const cargaComensalesLogiflexApi = {
  ejecutar: (proyectoId, body) =>
    pythonApiClient.post(`${BASE}/ejecutar`, body, {
      headers: headersProyecto(proyectoId),
    }),

  historial: (proyectoId) =>
    pythonApiClient.get(`${BASE}/historial`, {
      headers: headersProyecto(proyectoId),
    }),

  programacion: () => pythonApiClient.get(`${BASE}/programacion`),

  consultarPorDni: (dni) =>
    pythonApiClient.get(`${BASE}/consultar`, {
      params: { dni },
    }),
};

export default cargaComensalesLogiflexApi;
